import io from "socket.io-client";

var socket_cms = io("https://survey.besins-healthcare.vn");

export { socket_cms };
